module.exports = __webpack_public_path__ + "img/IFRS-Alliance-logo.c7a3f35f.jpg";